module.exports = __webpack_public_path__ + "static/balhannoth-20406dd484a75b24f6477b49cebe2c87.png";